const addSearchListeners = () => {
  document
    .querySelectorAll<HTMLButtonElement>(".clear-filter:not([data-listened])")
    .forEach((element) => {
      element.addEventListener("click", (e) => {
        if (
          !e.target ||
          !(e.target instanceof HTMLButtonElement) ||
          !e.target.dataset.target
        ) {
          return;
        }

        const target = document.getElementById(e.target.dataset.target);
        if (target) {
          target
            .querySelectorAll<HTMLInputElement>("input:not(.fixed), select")
            .forEach((input) => {
              if (input.type === "checkbox") {
                input.checked = false;
              } else {
                input.value = "";

                if (input.classList.contains("typeable_select")) return;

                input.dispatchEvent(new Event("filter_options"));
              }
            });

          target.dispatchEvent(
            new Event("submit", {
              bubbles: true,
              cancelable: true,
            }),
          );
          return false;
        }
      });

      element.dataset["listened"] = "true";
    });

  document
    .querySelectorAll<HTMLFormElement>(".search-form:not([data-listened])")
    .forEach((element) => {
      element.addEventListener("submit", () => {
        const target = element.dataset.target
          ? document.getElementById(element.dataset.target)
          : null;
        if (!target) return;

        target.innerHTML = `
          <i
            class='spinner-border d-block mx-auto text-primary'
            role='status'
            style='width: 10rem; height: 10rem;'
          >
            <span class="visually-hidden">Loading...</span>
          </i>
        `;
      });

      element
        .querySelectorAll<HTMLInputElement>(".immediate-submit")
        .forEach((input) => {
          input.addEventListener("input", () => {
            element.dispatchEvent(
              new Event("submit", {
                bubbles: true,
                cancelable: true,
              }),
            );
          });
        });

      element.dataset["listened"] = "true";

      if (element.dataset.isSubmit && element.matches(":not(.submitted)")) {
        const delay = Number(element.dataset.submitDelay || 0);
        setTimeout(() => {
          element.dispatchEvent(
            new Event("submit", {
              bubbles: true,
              cancelable: true,
            }),
          );
          element.classList.add("submitted");

          // Clear the inputs that are specified to only be included on the first submit
          element.querySelectorAll(".first-submit-input").forEach((input) => {
            input.remove();
          });
        }, delay);
      }
    });
};

document.addEventListener("DOMContentLoaded", addSearchListeners);
document.addEventListener("ajax:success", addSearchListeners);
